module.exports = __webpack_public_path__ + "img/icon-gen-ai-off.8af85a87.svg";